import { getAvailableRoles, getCurrentRole } from "../utils/roleSwitcher";
import { QUALITY_DASHBOARD_MODULE_ROUTES } from "./qualityDashboardModuleUi";

export function isQualityRoleSectionVisible(currentRole = getCurrentRole()) {
  if (currentRole == null) return true;
  return (
    String(currentRole.id) === "quality_inspector" ||
    String(currentRole.id) === "quality_inspector_service"
  );
}

export const QUALITY_DASHBOARD_MODULES = [
  {
    key: "overview",
    label: "Overview",
    to: "/auction/qa/dashboard",
    pathPrefixes: ["/auction/qa/dashboard"],
  },
  {
    key: "open_requests",
    label: "Open Requests",
    to: QUALITY_DASHBOARD_MODULE_ROUTES.open_requests,
    pathPrefixes: ["/auction/qa/dashboard/module/open-requests", "/auction/qa/dashboard/requests"],
  },
  {
    key: "quotations",
    label: "Quotations",
    to: QUALITY_DASHBOARD_MODULE_ROUTES.quotations,
    pathPrefixes: ["/auction/qa/dashboard/module/quotations"],
  },
  {
    key: "inspections",
    label: "Inspections",
    to: QUALITY_DASHBOARD_MODULE_ROUTES.inspections,
    pathPrefixes: ["/auction/qa/dashboard/module/inspections", "/auction/qa/dashboard/inspections"],
  },
  {
    key: "reports",
    label: "Reports",
    to: QUALITY_DASHBOARD_MODULE_ROUTES.reports,
    pathPrefixes: ["/auction/qa/dashboard/module/reports"],
  },
  {
    key: "completed",
    label: "Completed",
    to: QUALITY_DASHBOARD_MODULE_ROUTES.completed,
    pathPrefixes: ["/auction/qa/dashboard/module/completed", "/auction/qa/dashboard/completed"],
  },
  {
    key: "quality_metrics",
    label: "Quality Metrics",
    to: QUALITY_DASHBOARD_MODULE_ROUTES.quality_metrics,
    pathPrefixes: ["/auction/qa/dashboard/module/quality-metrics"],
  },
];

export const QUALITY_DASHBOARD_SUB_TABS = {
  open_requests: [{ key: "inbox", label: "Request inbox", to: "/auction/qa/dashboard/requests" }],
  quotations: [{ key: "quotes", label: "My quotations", to: "/auction/qa/dashboard/requests?filter=quoted" }],
  inspections: [{ key: "active", label: "Active inspections", to: "/auction/qa/dashboard/inspections" }],
  reports: [{ key: "submit", label: "Submit report", to: "/auction/qa/dashboard/completed" }],
  completed: [{ key: "all", label: "All completed", to: "/auction/qa/dashboard/completed" }],
};

export function buildQualityDashboardNavContext(currentRole = getCurrentRole()) {
  const roles = getAvailableRoles();
  const hasQualityRole = roles.some(
    (r) => r.id === "quality_inspector" || r.id === "quality_inspector_service",
  );
  const canAccessQualityDashboard = hasQualityRole && isQualityRoleSectionVisible(currentRole);

  return {
    roles,
    currentRole,
    hasQualityRole,
    canAccessQualityDashboard,
  };
}

export function getVisibleQualityDashboardModules(ctx) {
  if (!ctx.canAccessQualityDashboard) return [];
  return QUALITY_DASHBOARD_MODULES;
}

export function getVisibleQualityDashboardModuleKeys(ctx) {
  return getVisibleQualityDashboardModules(ctx).map((m) => m.key);
}

export function getVisibleQualityDashboardSubTabs(moduleKey) {
  return QUALITY_DASHBOARD_SUB_TABS[moduleKey] || [];
}

function pathMatchesModule(path, mod) {
  if (mod.key === "overview") {
    return path === "/auction/qa/dashboard" || path === "/auction/qa/dashboard/";
  }
  const prefixes = [mod.to, ...(mod.pathPrefixes || [])];
  return prefixes.some((prefix) => {
    if (mod.key === "open_requests" && path.startsWith("/auction/qa/dashboard/requests/")) {
      return false;
    }
    if (mod.key === "inspections" && path.startsWith("/auction/qa/dashboard/inspections/")) {
      return false;
    }
    return path === prefix || path.startsWith(`${prefix}/`) || path.startsWith(`${prefix}?`);
  });
}

export function resolveActiveQualityDashboardModule(pathname, modules) {
  const path = pathname || "";
  let best = modules.find((m) => m.key === "overview");
  let bestLen = 0;

  for (const mod of modules) {
    if (mod.key === "overview") continue;
    if (pathMatchesModule(path, mod)) {
      const prefixes = [mod.to, ...(mod.pathPrefixes || [])];
      const bestPrefix = prefixes
        .filter((prefix) => path === prefix || path.startsWith(`${prefix}/`) || path.startsWith(`${prefix}?`))
        .sort((a, b) => b.length - a.length)[0];
      const len = bestPrefix?.length || 0;
      if (len >= bestLen) {
        best = mod;
        bestLen = len;
      }
    }
  }

  if (path === "/auction/qa/dashboard" || path === "/auction/qa/dashboard/") {
    return modules.find((m) => m.key === "overview") || best;
  }

  return best || modules[0];
}

export function isSubTabActive(pathname, tab) {
  const path = pathname || "";
  return path === tab.to || path.startsWith(`${tab.to}/`) || path.startsWith(`${tab.to}?`);
}
